import { Pipe, PipeTransform } from '@angular/core';
import { TimeZonesEnum } from '@ep/shared';

export const TimeZonesMap: { [index: number]: string } = {
  [TimeZonesEnum.INTERNATIONALDATELINEWEST]: '(GMT-12:00) International Date Line West',
  [TimeZonesEnum.MIDWAYISLAND_SAMOA]: '(GMT-11:00) Midway Island, Samoa',
  [TimeZonesEnum.HAWAII]: '(GMT-10:00) Hawaii',
  [TimeZonesEnum.ALASKA]: '(GMT-09:00) Alaska',
  [TimeZonesEnum.PACIFICTIME]: '(GMT-08:00) Pacific Time (US & Canada)',
  [TimeZonesEnum.TIJUANA_BAJACALIFORNIA]: '(GMT-08:00) Tijuana, Baja California',
  [TimeZonesEnum.ARIZONA]: '(GMT-07:00) Arizona',
  [TimeZonesEnum.MOUNTAINTIME]: '(GMT-07:00) Mountain Time (US & Canada)',
  [TimeZonesEnum.CHIHUAHUA_LAPAZ_MAZATLAN]: '(GMT-07:00) Chihuahua, La Paz, Mazatlan',
  [TimeZonesEnum.CENTRALAMERICA]: '(GMT-06:00) Central America',
  [TimeZonesEnum.CENTRALTIME]: '(GMT-06:00) Central Time (US & Canada)',
  [TimeZonesEnum.GUADALAJARA_MEXICOCITY]: '(GMT-06:00) Guadalajara, Mexico City, Monterrey',
  [TimeZonesEnum.SASKATCHEWAN]: '(GMT-06:00) Saskatchewan',
  [TimeZonesEnum.BOGOTA_LIMA_QUITO_RIOBRANCO]: '(GMT-05:00) Bogota, Lima, Quito, Rio Branco',
  [TimeZonesEnum.EASTERNTIME]: '(GMT-05:00) Eastern Time (US & Canada)',
  [TimeZonesEnum.INDIANA]: '(GMT-05:00) Indiana (East)',
  [TimeZonesEnum.ATLANTICTIME]: '(GMT-04:00) Atlantic Time (Canada)',
  [TimeZonesEnum.LAPAZ]: '(GMT-04:00) La Paz',
  [TimeZonesEnum.MANAUS]: '(GMT-04:00) Manaus',
  [TimeZonesEnum.SANTIAGO]: '(GMT-04:00) Santiago',
};

@Pipe({
  standalone: true,
  name: 'timezone',
})
export class TimezonePipe implements PipeTransform {
  transform(value: TimeZonesEnum | null | undefined): string {
    if (value) {
      return TimeZonesMap[value];
    }
    return '';
  }
}
